<button
  #indicatorButton
  class="job-indicator-container"
  (click)="toggleJobsPanel()"
  [attr.aria-label]="'View ' + activeJobsCount + ' active job' + (activeJobsCount === 1 ? '' : 's')"
  [attr.aria-expanded]="isPanelOpen"
  data-testid="jobs-panel-toggle"
  [matTooltip]="jobStatusText"
  [matTooltipDisabled]="sidebarExpanded"
  matTooltipPosition="right"
  type="button"
>
  <div class="spinner-wrapper">
    <!-- Show animated spinner only when jobs are running -->
    <mat-spinner
      *ngIf="activeJobsCount > 0"
      [diameter]="38"
      [style.color]="'var(--color-tertiary-blue-cta)'"
    ></mat-spinner>
    <!-- Show static circle when no jobs running -->
    <svg
      *ngIf="activeJobsCount === 0"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      class="static-circle"
    >
      <circle
        cx="19"
        cy="19"
        r="17"
        fill="none"
        stroke="var(--color-tertiary-blue-cta)"
        stroke-width="2"
      />
    </svg>
    <span class="job-count">{{ activeJobsCount }}</span>
  </div>
  <span class="nav-text" *ngIf="sidebarExpanded">{{ jobStatusText }}</span>
</button>
